import { z } from 'zod';
export const teamMemberCreateSchema = z.object({
    name: z.string().min(1).max(120).trim(),
    role: z.string().min(1).max(120).trim(),
    bio: z.string().min(1).max(2000).trim(),
    photoUrl: z.string().url().nullable().optional(),
    order: z.number().int().min(0).default(0),
    isPublished: z.boolean().default(true),
});
export const teamMemberUpdateSchema = teamMemberCreateSchema.partial();
export const teamMemberSchema = z.object({
    id: z.string(),
    name: z.string(),
    role: z.string(),
    bio: z.string(),
    photoUrl: z.string().nullable(),
    order: z.number().int(),
    isPublished: z.boolean(),
});
//# sourceMappingURL=team.js.map